import { Component, HostListener, Input, OnInit, ElementRef, inject, output, input, viewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { JkBaseComponent } from '../jkbase/jkbase.component';
import { jkRestReturn } from '../../services/jkInterface';
import { Observable } from 'rxjs';
import { jkRestReturnClass } from '../../services/jkClass';
import { FileUploadMode, UploadHttpMethod } from '../jkupload/jkupload.component';
import { JktextComponent } from '../jktext/jktext.component';
import { JkMinioService, MinioImageItem } from '../../services/jk-minio.service';
import { MaterialModule } from '../../material.module';


export function initMinioConfig(
  form: any,
  disableClose: boolean = true,
  height: string = '95%',
  width: string = '95%',
  dialogClass: string = 'mat-dialog-container', //   custDialogClass: string ='custom-dialog-container' // 自定义样式类
): MatDialogConfig {
  let dialRet: jkRestReturn = new jkRestReturnClass();
  dialRet.obj = form;
  let dialConf: MatDialogConfig = {
    data: dialRet,
    hasBackdrop: true,
    //maxHeight: '90vh',
    //maxWidth: '90vw',
    maxWidth: '100vw',
    height: height,
    width: width,
    disableClose: disableClose,
    panelClass: dialogClass, // 預設就會顯示不出來!
  };
  return dialConf;
}

export function minioAttach(dialog: MatDialog, dbname: string, uploadHost: string, basePath: string, date: string, billType: string, billNo: string): Observable<any> {
  let uploadDirectory = `${basePath}/${dbname}/${date.substring(0, 6)}/${billType}-${billNo}`;
  let data = {
    uploadHost: uploadHost, // 上傳伺服器
    uploadDirectory: uploadDirectory, // 當前目錄
    uploadBaseUrl: '/minio',
    pathDisabled: true, // 是否禁用路徑選擇
    showNewFolderDialog: false, // 是否顯示新增資料夾按鈕
  };
  return dialog.open(UploadMinioComponent, initMinioConfig(data))
    .afterClosed();

}

export function minioAttachPath(dialog: MatDialog, uploadHost: string, path: string): Observable<any> {
  const data = {
    uploadHost: uploadHost,
    uploadDirectory: path,
    uploadBaseUrl: '/minio',
    pathDisabled: true,
    showNewFolderDialog: false,
  };
  return dialog.open(UploadMinioComponent, initMinioConfig(data)).afterClosed();
}


interface FileItem {
  name: string;
  type: 'file' | 'folder';
  size: number;
  path: string;
  url: string;
  modified: string | Date;
}

@Component({
  selector: 'app-upload-minio',
  imports: [FormsModule, JktextComponent, MaterialModule],
  templateUrl: './upload-minio.component.html',
  styleUrls: [],
  standalone: true
})
export class UploadMinioComponent extends JkBaseComponent implements OnInit {
  dialogRef = inject<MatDialogRef<UploadMinioComponent>>(MatDialogRef);
  retParams = inject<jkRestReturn>(MAT_DIALOG_DATA);
  override http = inject(HttpClient);

  override comType: string = 'upload-minio';
  _accept: string = '*';
  fileObj!: File;
  // 檔案瀏覽相關
  currentDirectory: string = '';
  fileList: FileItem[] = [];
  isLoading: boolean = false;
  selectedItems: FileItem[] = [];

  // 新增資料夾相關
  showNewFolderDialog: boolean = false;
  newFolderName: string = '';

  // 上傳檔案相關
  dragOver: boolean = false;

  readonly enabled = input(true);
  /*@Input() value: File[] = []; // 這裡不要再改了
  @Output() valueChange = new EventEmitter<any>();
  onValueChange(newValue: any) {
    this.valueChange.emit(newValue);
  }*/

  uploadChange!: (e: any) => void;

  programId: string = 'upload';
  selectButtonText: string = '選擇檔案';
  labelText: string = '拖曳檔案到此處，或貼上剪貼簿圖片';
  //uploadUrl: string = '';
  allowedFileExtensions: string[] = [];
  minFileSize: number = 0;
  maxFileSize: number = 1000000;
  @Input() uploadFile: any = (e: any) => {
    if (this.uploadChange) {
      this.uploadChange(e);
    } else {
      this.fileUploader_uploadFile(e, null);
    }
  };
  multiple = false;
  uploadMode: FileUploadMode = 'useButtons'; // useButtons, useForm, instantly
  uploadMethod: UploadHttpMethod = 'POST';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get accept(): string {
    return this._accept;
  };
  set accept(value: string) {
    this._accept = value;
    if (this.allowedFileExtensions.length > 0) {
      return;
    }
    if (value === '*') {
      this.allowedFileExtensions = [];
    }
    if (value === 'image/*') {
      this.allowedFileExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
    }
    if (value === 'video/*') {
      this.allowedFileExtensions = ['.mp4', '.avi', '.mov', '.mkv'];
    }
    if (value === 'audio/*') {
      this.allowedFileExtensions = ['.mp3', '.wav', '.ogg', 'm4a'];
    }
    if (value === 'application/*') {
      this.allowedFileExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt'];
    }
    if (value === 'application/pdf') {
      this.allowedFileExtensions = ['.pdf'];
    }
  };
  uploadBaseUrl: string = '/minio';
  uploadHost: string;
  //-------
    readonly value = input<string>('');
  readonly valueChange = output<string>();

  readonly path = input<string>('');
  readonly host = input<string>('');
  readonly minHeight = input<string>('250px');

  readonly imageInput = viewChild.required<ElementRef<HTMLInputElement>>('imageInput');

  private quillInstance: any;
  showMinioImages = false;
  minioImages: MinioImageItem[] = [];
  minioImagesLoading = false;

  private minioService = inject(JkMinioService);
  //private cdr = inject(ChangeDetectorRef);

  //-------
  constructor() {
    super();
    this.label.set('檔案上傳');
    this.uploadHost = this.retParams.obj.uploadHost; // 上傳伺服器
    this.currentDirectory = this.retParams.obj.uploadDirectory; // 當前目錄
    this.uploadBaseUrl = '/minio'; // MinIO API 路徑
    this.pathDisabled = this.retParams.obj.pathDisabled;  // 是否禁用路徑選擇
    this.showNewFolderDialog = this.retParams.obj.showNewFolderDialog; // 是否顯示新增資料夾按鈕
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loadFileList();
  }
  pathDisabled: boolean = false;
  override async ngAfterViewInit() {
    super.ngAfterViewInit();

  }

  // 檔案瀏覽相關方法
  async loadFileList() {
    this.isLoading = true;
    try {
      const data = await this.minioService.listFiles(this.uploadHost, this.currentDirectory);
      this.fileList = data.map((item) => ({
        name: item.name,
        type: 'file',
        size: item.size,
        path: item.objectPath,
        url: item.url,
        modified: item.lastModified || '',
      }));
    } catch (error: any) {
      let msg = 'upload-file.loadFileList error:' + error.message;
      alert(msg);
      console.error('Error loading file list:', error);
    } finally {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  navigateToFolder(_folder: FileItem) {
    return;
  }

  navigateUp() {
    return;
  }

  // 檔案選擇相關方法
  toggleSelection(item: FileItem, event: MouseEvent) {
    event.stopPropagation();

    const index = this.selectedItems.findIndex(i => i.path === item.path);
    if (index === -1) {
      this.selectedItems.push(item);
    } else {
      this.selectedItems.splice(index, 1);
    }
  }

  isSelected(item: FileItem): boolean {
    return this.selectedItems.some(i => i.path === item.path);
  }

  // 檔案上傳相關方法
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      void this.uploadFiles(input.files);
      input.value = '';
    }
  }

  async uploadFiles(files: FileList | File[]) {
    try {
      for (let i = 0; i < files.length; i++) {
        await this.minioService.uploadFile(this.uploadHost, this.currentDirectory, files[i]);
      }
      await this.loadFileList();
    } catch (error: any) {
      console.error('Error uploading files:', error);
      alert('上傳檔案失敗: ' + error.message);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = false;

    if (event.dataTransfer?.files) {
      void this.uploadFiles(event.dataTransfer.files);
    }
  }

  // 資料夾操作相關方法
  createFolder() {
    if (!this.newFolderName.trim()) {
      alert('請輸入資料夾名稱');
      return;
    }

    const body = {
      folderName: this.newFolderName,
      directory: this.currentDirectory
    };
    let params = `?fromRoot=true&filePath=${this.currentDirectory}&folderName=${this.newFolderName}`;

    this.http.put(`${this.uploadHost}${this.uploadBaseUrl}/folder` + params, body)
      .subscribe({
        next: () => {
          this.newFolderName = '';
          this.showNewFolderDialog = false;
          this.cdr.detectChanges();
          this.loadFileList();
        },
        error: (error) => {
          alert('新增資料夾失敗: ' + error.message);
          console.error('Error creating folder:', error);
        }
      });
  }

  deleteSelectedItems() {
    if (this.selectedItems.length === 0) return;

    if (!confirm(`確定要刪除選中的 ${this.selectedItems.length} 個項目嗎？`)) {
      return;
    }

    const deletePromises = this.selectedItems.map((item) => this.minioService.deleteFile(this.uploadHost, item.path));

    Promise.all(deletePromises)
      .then(() => {
        this.selectedItems = [];
        this.loadFileList();
      })
      .catch(error => {
        console.error('Error deleting items:', error);
        alert('刪除項目時發生錯誤: ' + error.message);
        // Still refresh the list even if there was an error
        this.selectedItems = [];
        this.loadFileList();
      });
  }


  async fileUploader_uploadFile(xfile: File, progressCallback: any) {
    if (!xfile) return;

    if (progressCallback)
      progressCallback(100);
    if (progressCallback)
      progressCallback(200);

    this.fileObj = xfile;
    if (this.fileObj) {
      if (this.fileObj.size > this.maxFileSize) {
        alert('檔案大小超過限制');
        return;
      }

      await this.minioService.uploadFile(this.uploadHost, this.currentDirectory, this.fileObj);
      await this.loadFileList();
    }
  }

  // 格式化檔案大小
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // 格式化日期
  formatDate(dateString: string | Date): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString();
  }
  doOk(e: any) {
    this.retParams.rowsAffected = this.fileList.length;
    this.dialogRef.close(this.retParams);
  }
  doCancel(e: any) {
    this.dialogRef.close(this.retParams);
  }
  downloadUrl: string = '';
  downloadFile(item: FileItem) {
    if (item.type !== 'file') {
      alert('只能下載檔案，不能下載資料夾');
      return;
    }
    this.downloadUrl = item.url;
    let a = document.getElementById('downloadLink') as HTMLAnchorElement;
    if (a) {
      a.href = this.downloadUrl;
      a.download = item.name;
      a.click();
    }
    alert(item.name + '已下載');
  }
  downloadSelectedItems() {
    if (this.selectedItems.length === 0) {
      alert('請先選擇要下載的檔案');
      return;
    }

    const filePaths = this.selectedItems
      .filter(item => item.type === 'file')
      .map(item => item.path);

    if (filePaths.length === 0) {
      alert('所選項目中沒有檔案可供下載。');
      return;
    }

    // 假設後端 API 端點是 /batch-download
    // TODO: 後端未改 batch-download
    const batchDownloadUrl = `${this.uploadHost}${this.uploadBaseUrl}/batch-download`;

    // 使用 POST 請求將檔案路徑列表傳遞給後端
    this.http.post(batchDownloadUrl, { filePaths }, {
      responseType: 'blob', // 期待後端回傳一個檔案 Blob
      observe: 'response' // 獲取完整的 HTTP 回應，以便讀取檔名
    }).subscribe({
      next: (response) => {
        // 從 Content-Disposition 標頭獲取檔名
        const contentDisposition = response.headers.get('content-disposition');
        let filename = 'download.zip'; // 預設檔名
        if (contentDisposition) {
          const filenameRegex = /filename[^;=]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 建立一個 URL 來觸發下載
        const blob = new Blob([response.body!], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);

        // 建立一個隱藏的 a 標籤來觸發下載
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        // 下載後清除選擇
        this.selectedItems = [];
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Batch download error:', error);
        alert('下載多個檔案時發生錯誤: ' + error.message);
      }
    });
  }
  // ---------------------------
  async onImageFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    input.value = '';
    try {
      await this.minioService.uploadFile(this.uploadHost, this.currentDirectory, file);
      await this.loadFileList();
    } catch (e) {
      console.error('上傳圖片至 MinIO 失敗', e);
      alert('上傳圖片失敗，請確認 MinIO 服務已啟動');
    }
  }
  private insertImageToEditor(url: string) {
    if (!this.quillInstance) return;
    const range = this.quillInstance.getSelection(true);
    this.quillInstance.insertEmbed(range.index, 'image', url);
    this.quillInstance.setSelection(range.index + 1);
  }

  async toggleMinioImages() {
    this.showMinioImages = !this.showMinioImages;
    if (!this.showMinioImages || this.minioImages.length > 0) return;
    this.minioImagesLoading = true;
    this.minioImages = [];
    try {
      this.minioImages = await this.minioService.listImages(this.uploadHost, this.currentDirectory);
    } catch (e) {
      console.error('載入 MinIO 圖片失敗', e);
    } finally {
      this.minioImagesLoading = false;
      this.cdr.detectChanges();
    }
  }

  insertMinioImage(url: string) {
    this.insertImageToEditor(url);
    this.showMinioImages = false;
  }

  @HostListener('document:paste', ['$event'])
  async onPaste(event: ClipboardEvent) {
    const items = Array.from(event.clipboardData?.items || []);
    const imageItem = items.find((item) => item.type.startsWith('image/'));
    if (!imageItem) return;

    event.preventDefault();
    const blob = imageItem.getAsFile();
    if (!blob) return;

    try {
      const pngFile = await this.toPngFile(blob);
      await this.uploadFiles([pngFile]);
    } catch (error: any) {
      console.error('Paste image upload error:', error);
      alert('貼上圖片上傳失敗: ' + error.message);
    }
  }

  private async toPngFile(file: File): Promise<File> {
    const image = await createImageBitmap(file);
    const canvas = document.createElement('canvas');
    canvas.width = image.width;
    canvas.height = image.height;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('無法建立圖片轉檔畫布');
    context.drawImage(image, 0, 0);
    const blob = await new Promise<Blob>((resolve, reject) => {
      canvas.toBlob((result) => result ? resolve(result) : reject(new Error('圖片轉 PNG 失敗')), 'image/png');
    });
    image.close();
    return new File([blob], `${this.formatFileTimestamp()}.png`, { type: 'image/png' });
  }

  private formatFileTimestamp(): string {
    const date = new Date();
    const pad = (value: number) => value.toString().padStart(2, '0');
    return `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}-${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
  }


}
